<template>
  <v-card class="import-section">
    <v-card-title class="justify-center">
      {{ replacingSection ? $t('section.edit_title') : $t('section.import_title') }}
    </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('section.order_no') }}
          </v-col>
          <v-col cols="9">
            <v-text-field outlined
                          dense
                          type="number"
                          min="1"
                          v-model="orderNo"
                          :readonly="replacingSection"
                          :rules="requiredRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('section.name') }}
          </v-col>
          <v-col cols="9">
            <v-text-field outlined
                          dense
                          v-model="sectionName"
                          :readonly="replacingSection"
                          :rules="requiredRules"></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('section.section_excel') }}
          </v-col>
          <v-col cols="9">
            <FileInput v-model="excelFile"
                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                       :rules="requiredRules"></FileInput>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3"
                 class="input-label">{{ $t('section.special_conditions') }}
          </v-col>
          <v-col cols="9">
            <FileInput v-model="specialConditionsFile"
                       accept="application/pdf"></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary"
             @click="$emit('submit', false)"
             depressed
             large>
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="primary"
             @click="$refs.form.validate() && confirm()"
             depressed
             large>
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {onMounted, ref} from "@vue/composition-api";
import {ACTION_TYPES} from "@/store/types";
import FileInput from "@/components/FileInput";

export default {
  name: 'ImportSectionDialog',
  components: {FileInput},
  props: {
    sorId: String,
    volumeId: String,
    replacingSection: Object,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('rules.required'),
    ]);

    const orderNo = ref(null);
    const sectionName = ref(null);
    const excelFile = ref(null);
    const specialConditionsFile = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append('sor_id', props.sorId);
      formData.append('volume_id', props.volumeId);
      formData.append('section_id', props.replacingSection ? props.replacingSection.id : '')
      formData.append('order_no', orderNo.value);
      formData.append('name', sectionName.value);
      formData.append('excel', excelFile.value, excelFile.value.name);
      if (specialConditionsFile.value) {
        formData.append('special_conditions', specialConditionsFile.value, specialConditionsFile.value.name);
      }

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: 'admin/section/import/',
        params: formData,
      });

      if (response.body.success) {
        emit('submit', true)
      }
    }

    onMounted(() => {
      if (props.replacingSection) {
        orderNo.value = props.replacingSection.order_no;
        sectionName.value = props.replacingSection.name;
      }
    })

    return {
      requiredRules,

      orderNo,
      sectionName,

      excelFile,
      specialConditionsFile,

      confirm,
    }
  },
}
</script>

<style lang="less">
.import-section {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
